// extracted by mini-css-extract-plugin
export default {"sideNavigation":"navigation_sideNavigation__fWI1v","li":"navigation_li__SEjwo","link":"navigation_link__ARlrN"};